// Dialog.js
import React from "react";
import check_circles from "../../assets/icons/check_circle.svg";

function DropDown({
  isOpen,
  onClick,
  items,
  selected,
  top = 0,
  right = 0,
  left = 0,
  bottom = 0,
  className,
}) {
  if (!isOpen || !Array.isArray(items)) return null;

  let position = {};
  if (top) {
    position.top = `${top}rem`;
  }
  if (right) {
    position.right = `${right}rem`;
  }
  if (left) {
    position.left = `${left}rem`;
  }
  if (bottom) {
    position.bottom = `${bottom}rem`;
  }

  return (
    <div
      className={`absolute z-50 rounded-lg shadow-lg px-2 py-6 flex flex-col w-56 dark:!bg-dark-secondary !bg-sunny-primary ${className}`}
      style={{ ...position }}
    >
      {items.map((item, index) => (
        <div
          className="flex w-full items-center gap-3 hover:bg-sunny-secondary dark:hover:bg-dark-primary px-2 py-5"
          key={item.label + index}
          onClick={() => onClick({ target: item })}
        >
          {item.icon ? (
            item.icon
          ) : (
            <div className="rounded-full size-4 bg-violet-800"> </div>
          )}
          <p className="flex-grow text-sm">
            {" "}
            {item.label ? item.label : "none"}{" "}
          </p>
          {item.name === selected ? (
            // <div className=" bg-slate-300 text-xl">&#10003;</div>
            <div>
              <img src={check_circles} alt="checked" />
            </div>
          ) : (
            <div className=" bg-slate-300">{""}</div>
          )}
        </div>
      ))}
    </div>
  );
}

export default DropDown;
